import {Component, Input, OnInit} from '@angular/core';
import {ManageEntitiesComponent} from '../../manage-entities/manage-entities.component';
import {LeftpanelComponent} from '../leftpanel.component';

@Component({
  selector: 'app-apimenupanel',
  templateUrl: './apimenupanel.component.html',
  styleUrls: ['./apimenupanel.component.scss']
})
export class ApimenupanelComponent implements OnInit {

  @Input() partner: string;
  @Input() account: string;
  @Input() pkey = localStorage.getItem('partnerKey');
  @Input() item: any;
  @Input() apimanagement = '/apimanagement/';
  @Input() deleteAccess = false;
  @Input() SideMenuNavigationUrl = '';
  @Input() selectedMenu = 'Data Access API';
  @Input() type = 'DATAACCESS';
  @Input() editUrl = '/entity/edit/';
  @Input() promotionLink = '/promotion/';

  constructor(public manageEntities: ManageEntitiesComponent, public platform: LeftpanelComponent) { }

  ngOnInit() {
  }

  getVersion(val) {
    /* var str = Object.values(val).toString();
     return str.substr(str.indexOf('.') + 1, str.length);*/
    const data = val.split('#');
    return data[1];
  }

  getEntity(val) {
    const data = val.split('#');
    /* var str = Object.values(val).toString();
     return str.substr(0, str.indexOf('.')).toString();*/
    return data[0];
  }
}
